module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grid container"
  }, [(_vm.showStoreOfferControl) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column right aligned"
  }, [_c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isStoreOffer
    },
    on: {
      "change": _vm.toggleStoreOffer
    }
  }), _vm._v(" "), _c('label', [_vm._v("採用門市價")])])])]) : _vm._e(), _vm._v(" "), (_vm.inCart && _vm.price) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui horizontal blue large statistic right floated"
  }, [_c('div', {
    staticClass: "value price"
  }, [_vm._v(_vm._s(_vm.price))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4150819a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TotalPrice.vue
// module id = 378
// module chunks = 0